export type DataPointData = {
	timestamp: number | null | undefined;
	value: any | null | undefined;
};
export type AssetInfoData = Record<string, DataPointData | null | undefined>;
export enum InfoType {
	HARDWARE = 'hardware',
	SOFTWARE = 'software',
	NETWORK = 'network',
	CERTIFICATE = 'certificate',
	FIRMWARE = 'firmware'
}
